import axios from 'axios';
import {API_ROOT} from './config';
import {helper} from './util';

const http = axios.create({
  baseURL: API_ROOT,
  withCredentials: true, 
  timeout: 6*60*1000 //设置超时
});
// export default helper(http)
export default async function() {
  return await helper(http)
}
